import { combineReducers, createStore } from 'redux';
import { counterReducer } from './reducers/wishlistReducer';

const rootReducer = combineReducers({
    counterReducer,
});

export default createStore(rootReducer);
